module.exports = "//cdn.mxpnl.com/static/asset-cache/2a0345386f9d0ee940e8c659c7c77918/iron/common/assets/images/customer-logos/docusign-logo.png";